{
  "FormEngineConditionWfl": {
    "title": "Zustand",
    "description": "Beschränken Sie die Ausführung auf die Erfüllung einer Bedingung"
  },
  "mask": {
    "FormEngineConditionWfl": {
      "groupTitle": "Zustand"
    }
  }
}